import { msalInstance, iffLoginRequest } from "./msal";

export async function login() {
  try {
    await msalInstance.loginRedirect(iffLoginRequest);
  } catch (error) {
    return error;
  }
}
